import React from "react";
import { Typography } from "antd";

export function secondary(value) {
  return <Typography.Text type="secondary">{value}</Typography.Text>;
}
